import { AxiosInstance } from 'axios';
import {
  IFetchChatsParams,
  IFetchChatsResponse,
  TFetchOneChatResponse,
} from '@sv-support-sdk/shared-types/src/api/chats';

export default (api: AxiosInstance) => ({
  fetchChats: (params: IFetchChatsParams): Promise<IFetchChatsResponse> =>
    api.get('/chat', { params }),
  fetchOneChat: (chatId: string): Promise<TFetchOneChatResponse> => api.get(`/chat/${chatId}`),
});
